var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.copyURL.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('Icon',{attrs:{"name":"btCopy","width":"54"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }